/**
 * @memberOf app
 * @ngdoc module
 * @description Login module used for the login part of application -- putting in email address on the login form
 * @name app.login
 */

import routing from './login.route';
import LoginController from './login.controller';
import LoginService from '../services/login.service';
import AuthService from '../services/auth.service';

export default angular.module('app.login', [LoginService, AuthService])
  .config(routing)
  .controller('LoginController', LoginController)
  .name;


// WEBPACK FOOTER //
// ./src/client/app/login/login.module.js